<div>
  <!-- Header con gradiente -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">add_business</mat-icon>
      <h2 class="text-lg font-bold text-gray-800 m-0">Registrar Cuenta Bancaria VES</h2>
    </div>
  </div>

  <div class="p-5">
    <!-- Loading cuentas -->
    <div *ngIf="loadingCuentas" class="flex items-center justify-center py-8 gap-3">
      <mat-spinner diameter="28"></mat-spinner>
      <span class="text-sm text-gray-500">Cargando cuentas de trabajo...</span>
    </div>

    <form *ngIf="!loadingCuentas" [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">

      <!-- Selector de cuenta de trabajo VE -->
      <mat-form-field appearance="outline" class="w-full modern-field">
        <mat-label>Seleccionar cuenta de trabajo VE</mat-label>
        <mat-select formControlName="cuentaTrabajoId" (selectionChange)="onCuentaSelected($event.value)">
          <mat-option *ngFor="let cuenta of cuentasTrabajo"
            [value]="cuenta.cuenta_trabajo_id"
            [disabled]="cuenta.yaRegistrada">
            {{ cuenta.nombre | titlecase }} {{ cuenta.apellidos | titlecase }}
            — {{ cuenta.banco?.nombre }} {{ cuenta.numeroCuenta }}
            <span *ngIf="cuenta.yaRegistrada"> (ya registrada)</span>
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('cuentaTrabajoId')?.hasError('required')">Seleccione una cuenta</mat-error>
      </mat-form-field>

      <!-- Warning si no hay cuentas disponibles -->
      <div *ngIf="cuentasTrabajo.length === 0 && !loadingCuentas"
        style="display: flex; align-items: center; gap: 8px; justify-content: center; background: #fef3c7; padding: 8px 16px; border-radius: 10px; border: 1px solid #fde68a;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #f59e0b;">warning</mat-icon>
        <span style="font-size: 0.8rem; font-weight: 600; color: #92400e;">No hay cuentas de trabajo VE disponibles</span>
      </div>

      <!-- Datos de la cuenta seleccionada (solo lectura) -->
      <div *ngIf="cuentaSeleccionada" class="space-y-3">
        <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 16px;" class="space-y-2">
          <div class="grid grid-cols-2 gap-3 text-sm">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Titular</span>
              <p class="text-gray-800 font-semibold mt-0.5">{{ form.getRawValue().nombreTitular }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">RIF / Cédula</span>
              <p class="text-gray-700 font-mono mt-0.5">{{ form.getRawValue().rifCedula }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Banco</span>
              <p class="text-gray-700 mt-0.5">{{ form.getRawValue().banco }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo Cuenta</span>
              <p class="text-gray-700 mt-0.5" style="text-transform: capitalize;">{{ form.getRawValue().tipoCuenta }}</p>
            </div>
            <div class="col-span-2">
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Número Cuenta</span>
              <p class="text-gray-700 font-mono mt-0.5">{{ form.getRawValue().numeroCuenta }}</p>
            </div>
          </div>
        </div>

        <!-- Warning si ya está registrada -->
        <div *ngIf="cuentaSeleccionada.yaRegistrada"
          style="display: flex; align-items: center; gap: 8px; justify-content: center; background: #fef3c7; padding: 8px 16px; border-radius: 10px; border: 1px solid #fde68a;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #f59e0b;">warning</mat-icon>
          <span style="font-size: 0.8rem; font-weight: 600; color: #92400e;">Esta cuenta ya se encuentra registrada</span>
        </div>
      </div>

      <div class="flex justify-end gap-3 pt-2">
        <button type="button" (click)="onCancel()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          Cancelar
        </button>
        <button type="submit"
          [disabled]="loading || !cuentaSeleccionada || cuentaSeleccionada.yaRegistrada"
          [style.opacity]="loading || !cuentaSeleccionada || cuentaSeleccionada.yaRegistrada ? '0.5' : '1'"
          [style.cursor]="loading || !cuentaSeleccionada || cuentaSeleccionada.yaRegistrada ? 'not-allowed' : 'pointer'"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon *ngIf="!loading" style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
          <span *ngIf="!loading">Registrar</span>
          <span *ngIf="loading">Guardando...</span>
        </button>
      </div>
    </form>
  </div>
</div>
